module.exports = __webpack_public_path__ + "static/media/sistemaPegar14.1550ccf5.jpg";